const isIntra = document.body.getAttribute("data-theme") === "intranet";
if (isIntra) {
    const dropdownBtn = document.getElementById("dropdown-btn") as HTMLButtonElement;
    const dropdownList = document.getElementById("dropdown-list") as HTMLUListElement;
    const dropdownItems = Array.from(dropdownList.querySelectorAll(".megamenu__department__dropdown-item"));

    let currentIndex = -1; // Håller koll på markerat index
    const defaultText = "Välj förvaltning"; // Standardtext

    // Hämta den aktuella sidans URL och ta bort trailing "/"
    const currentUrl = window.location.href.replace(/\/$/, "");

    // Hämta sparat värde från localStorage
    let storedText = localStorage.getItem("selectedDropdownText");

    // Hitta den dropdown-item som matchar URL:en
    const matchingItem = dropdownItems.find(item => item.hasAttribute("data-selected"));

    // Om vi hittar en matchande dropdown-item, uppdatera localStorage om det behövs
    if (matchingItem) {
        const correctText = matchingItem.textContent?.trim();
        if (storedText !== correctText) {
            localStorage.setItem("selectedDropdownText", correctText || "");
        }
        storedText = correctText; // Uppdatera variabeln
    } else {
        // Om ingen matchning, återställ localStorage till standardtexten
        localStorage.removeItem("selectedDropdownText");
        storedText = defaultText;
    }

    // Uppdatera knappen med rätt värde vid sidladdning
    const spanElement = dropdownBtn.querySelector("span");
    if (spanElement) {
        spanElement.textContent = storedText || defaultText;
    }

    // Funktion för att öppna/stänga dropdown
    const toggleDropdown = () => {
        dropdownList.classList.toggle("show");

        if (dropdownList.classList.contains("show")) {
            currentIndex = -1; // Återställ index när dropdown öppnas
            dropdownItems[0]?.focus(); // Sätt fokus på första alternativet
        }
    };

    // Funktion för att välja ett alternativ och uppdatera knappen
    const selectItem = (item: HTMLLIElement) => {
        const selectedText = item.textContent?.trim() || defaultText;
        const selectedUrl = item.getAttribute("data-url");

        // Uppdatera texten i knappen
        if (spanElement) {
            spanElement.textContent = selectedText;
        }

        // Spara endast valet om det är något annat än standardvärdet
        if (selectedText !== defaultText) {
            localStorage.setItem("selectedDropdownText", selectedText);
        } else {
            localStorage.removeItem("selectedDropdownText");
        }

        // Navigera till vald URL om det finns
        if (selectedUrl) {
            window.location.href = selectedUrl;
        }

        dropdownList.classList.remove("show");
    };

    // Klicka på knappen för att öppna/stänga dropdown
    dropdownBtn.addEventListener("click", toggleDropdown);

    // Välj alternativ från listan vid klick
    dropdownItems.forEach((item) => {
        item.addEventListener("click", () => selectItem(item));
    });

    // Stäng dropdown när man klickar utanför
    document.addEventListener("click", (event) => {
        if (!dropdownBtn.contains(event.target as Node) && !dropdownList.contains(event.target as Node)) {
            dropdownList.classList.remove("show");
        }
    });

    // Tangentbordsnavigering
    document.addEventListener("keydown", (event) => {
        if (!dropdownList.classList.contains("show")) return; // Om dropdown är stängd, gör inget

        if (event.key === "ArrowDown") {
            event.preventDefault();
            currentIndex = (currentIndex + 1) % dropdownItems.length; // Cirkulär navigering nedåt
        }
        else if (event.key === "ArrowUp") {
            event.preventDefault();
            currentIndex = (currentIndex - 1 + dropdownItems.length) % dropdownItems.length; // Cirkulär navigering uppåt
        }
        else if (event.key === "Enter" && currentIndex >= 0) {
            event.preventDefault();
            selectItem(dropdownItems[currentIndex]); // Välj det markerade alternativet
        }
        else if (event.key === "Escape") {
            event.preventDefault();
            dropdownList.classList.remove("show"); // Stäng dropdown med ESC
        }

        // Uppdatera visuell markering och sätt fokus
        dropdownItems.forEach((item, index) => {
            if (index === currentIndex) {
                item.classList.add("selected");
                item.focus(); // Ger visuell feedback genom att fokusera elementet
            } else {
                item.classList.remove("selected");
            }
        });
    });
}
